import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "reward-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "overlay-text" }
const _hoisted_5 = { class: "peopleText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.received != 1)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "box-img",
          src: _ctx.boxImg,
          alt: ""
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "box-img",
          src: _ctx.boxImg2,
          alt: ""
        }, null, 8, _hoisted_3)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.peopleCount) + " " + _toDisplayString(_ctx.$t('common.pepole')), 1),
      _createElementVNode("div", {
        style: _normalizeStyle([{"color":"#ffffffa6","font-size":"12px"}, { color: _ctx.received == 1 ? '#f0a853' : '', fontWeight: _ctx.received == 1 ? '600' : '100' }]),
        class: "rewardNum"
      }, [
        _createElementVNode("div", null, _toDisplayString(Number(_ctx.reward)), 1)
      ], 4)
    ])
  ]))
}